// extracted by mini-css-extract-plugin
export default {"preview-video":"preview-video__i0MlO"};